import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, withKeys as _withKeys, createSlots as _createSlots, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "login-container"
};
const _hoisted_2 = {
  class: "login-title",
  tabindex: "0"
};
const _hoisted_3 = {
  class: "input-wrapper"
};
const _hoisted_4 = {
  key: 0,
  class: "loading-ring"
};
const _hoisted_5 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ToggleDark = _resolveComponent("ToggleDark");
  const _component_LanguageSwitcher = _resolveComponent("LanguageSwitcher");
  const _component_Logo = _resolveComponent("Logo");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  const _component_Footer = _resolveComponent("Footer");
  return _openBlock(), _createElementBlock("div", {
    class: "login",
    style: _normalizeStyle($options.viewportStyle)
  }, [_createVNode(_component_ToggleDark, {
    class: "toggle-dark"
  }), _createVNode(_component_LanguageSwitcher, {
    class: "language-switcher"
  }), _createVNode(_component_Logo), _createElementVNode("div", _hoisted_1, [_createElementVNode("h1", _hoisted_2, _toDisplayString($props.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.fields, (field, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: field.key,
      class: "input-container"
    }, [_createElementVNode("label", {
      class: "input-name",
      ref_for: true,
      ref: `inputLabel${index}`,
      style: _normalizeStyle({
        '--underline-width': $data.labelUnderlineWidths[index] + 'px'
      })
    }, _toDisplayString(field.label), 5), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
      modelValue: $data.formData[field.key],
      "onUpdate:modelValue": $event => $data.formData[field.key] = $event,
      placeholder: field.placeholder,
      type: field.type || 'text',
      "show-password": field.showPassword,
      class: "password-input",
      onKeyup: _withKeys($options.handleSubmit, ["enter", "native"]),
      onFocus: $options.handleInputFocus,
      onBlur: $options.handleInputBlur
    }, _createSlots({
      _: 2
    }, [field.icon ? {
      name: "prefix",
      fn: _withCtx(() => [_createVNode(_component_el_icon, {
        class: "el-input__icon"
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(field.icon)))]),
        _: 2
      }, 1024)]),
      key: "0"
    } : undefined]), 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "type", "show-password", "onKeyup", "onFocus", "onBlur"])])]);
  }), 128)), _createVNode(_component_el_button, {
    class: _normalizeClass(["submit", {
      'is-loading': $props.loading
    }]),
    type: "primary",
    onClick: $options.handleSubmit,
    disabled: $props.loading
  }, {
    default: _withCtx(() => [$props.loading ? (_openBlock(), _createElementBlock("div", _hoisted_4)) : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($options.computedSubmitText), 1))]),
    _: 1
  }, 8, ["class", "onClick", "disabled"])]), _createVNode(_component_Footer, {
    class: "footer"
  })], 4);
}